import React from 'react'

const WaveAnimation = ({ isActive = false, barCount = 5, audioLevels = [0, 0, 0, 0, 0] }) => {
  const bars = Array.from({ length: barCount }, (_, index) => {
    const level = audioLevels[index] || 0
    // Calculate height based on audio level (minimum 4px, maximum based on predefined heights)
    const baseHeight = 4
    const maxHeightMap = [12, 20, 16, 24, 10] // Increased max heights for more dramatic effect

    // Add minimum animation level when recording but no sound
    const effectiveLevel = isActive ? Math.max(level, 0.1) : 0
    const dynamicHeight = isActive ? baseHeight + effectiveLevel * (maxHeightMap[index] - baseHeight) : baseHeight

    return (
      <div
        key={index}
        className={`wave-bar ${isActive ? 'active' : ''}`}
        style={{
          height: `${dynamicHeight}px`,
          opacity: isActive ? 0.7 + effectiveLevel * 0.3 : 0.6,
          transition: 'height 0.05s ease, opacity 0.05s ease' // Faster transitions
        }}
      />
    )
  })

  return <div className='wave-animation-container'>{bars}</div>
}

export default WaveAnimation
